/**
 * 群列表按未读数降序排列（稳定排序，无未读的群保持原相对顺序）。
 * 动机：同名群/长列表里，用户找不到该进哪个群——未读群置前 + 卡片高亮
 * 让「去看哪条未读」零思考（配合卡片上的「N 条新」气泡）。
 */
export function sortGroupsByUnread<T extends { _id: string }>(
  groups: T[],
  byGroup: Map<string, number>,
): T[] {
  return [...groups].sort(
    (a, b) => (byGroup.get(b._id) || 0) - (byGroup.get(a._id) || 0),
  )
}
